import React from "react";
import {Tooltip} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {CheckboxController, CreditCardPreview} from "../PaymentInputHelper.jsx";
import {PaymentType} from "../../../../consts.js";
import "./ten-bis-payment-input.css";
import {GroupedDigitInput} from "../../../../components/GroupedDigitInput";
import classnames from "classnames";
import {getTenBisLastFourDigits} from "./utils.js";

export const TenBisPaymentInput = ({paymentType, setPaymentType, updateFormValues, tenBisCreditCard}) => {
    return (
        <>
            <div className={classnames("ten-bis-payment-input-container")}>
                <div className="payment-input-options-header">
                    <CheckboxController
                        isChecked={paymentType === PaymentType.TenBisCard}
                        setPaymentType={setPaymentType}
                        type={PaymentType.TenBisCard}
                    />
                    תקציב מחשבון תן ביס
                    <Tooltip
                        title={
                            <p className="payment-input-tooltip-text">
                                בעת ביצוע ההזמנה חשוב לשים לב אם קיימת לכם מגבלת תקציב יומית/חודשית
                            </p>
                        }>
                        <QuestionCircleOutlined className="payment-input-tooltip-icon" />
                    </Tooltip>
                </div>

                <CreditCardPreview last4Digits={getTenBisLastFourDigits(tenBisCreditCard)} />

                <GroupedDigitInput
                    onUpdate={value => updateFormValues("tenBisCreditCard", value)}
                    className="ten-bis-payment-input-digit-group-container"
                    disabled={paymentType !== PaymentType.TenBisCard}
                />
            </div>
        </>
    );
};
